import { gql } from "@apollo/client";

export const getPopularLocationQuery = gql`
query getPopularLocationAdmin {
  getPopularLocationAdmin {
    id
    location
    locationAddress
    image
    isEnable
    createdAt
    updatedAt
    dynamicPopularLocation {
      id
      locationId
      language
      location
    }
  }
}`;

export const getImageBannerQuery = gql`
{
  getImageBanner {
    id
    title
    description
    buttonLabel
    image
    buttonLabel2
    buttonLink1
    buttonLink2
    dynamicImageBanner {
      id
      bannerId
      language
      title
      buttonLabel
      buttonLabel2
    }
  }
}
`;

export const getStaticInfo = gql`
{
  getStaticInfo {
    id
    title
    name
    value
  }
}`;

export const getMostViewedListingQuery = gql`
{
  GetMostViewedListing {
    id
    title
    personCapacity
    beds
    bookingType
    coverPhoto
    reviewsCount
    reviewsStarRating
    transmission
    userId
    listPhotos {
      id
      name
      type
      status
    }
    listingData {
      weeklyDiscount
      monthlyDiscount
      basePrice
      currency
    }
    settingsData {
      listsettings {
        id
        itemName
        typeId
      }
    }
    wishListStatus
    isListOwner
  }
}`;

export const getRecommendQuery = gql`
query getRecommend {
  getRecommend {
    id
    title
    personCapacity
    beds
    bookingType
    coverPhoto
    reviewsCount
    reviewsStarRating
    transmission
    userId
    listPhotos {
      id
      name
      type
      status
    }
    listingData {
      weeklyDiscount
      monthlyDiscount
      basePrice
      currency
    }
    settingsData {
      listsettings {
        id
        itemName
        typeId
      }
    }
    wishListStatus
    isListOwner
  }
}`;

export const getBannerQuery = gql`
query getBanner {
  getBanner {
    id
    title
    content
    image
    dynamicBanner {
      id
      bannerId
      language
      title
      content
    }
  }
}`;
